import { useEffect, useState } from 'react';

import {
	getRoadmapFeatures,
	ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE,
	RoadmapFeaturesQueryResult,
	RoadmapName,
} from './client';

export interface UseQueryProps {
	locale: string;
	roadmapName: RoadmapName;
}
export function useQuery(props: UseQueryProps) {
	const { locale, roadmapName } = props;

	const [result, setResult] = useState<RoadmapFeaturesQueryResult | undefined>(undefined);
	const [pending, setPending] = useState(false);

	useEffect(() => {
		setPending(true);
		getRoadmapFeatures({
			locale,
			limit: ROADMAP_FEATURES_ALL_ITEMS_PAGE_SIZE,
			roadmapName,
		})
			.then(setResult)
			.finally(() => {
				setPending(false);
			});
	}, []);

	return {
		result,
		pending,
	};
}
